export default "__VITE_ASSET__20093839__"